import { render, staticRenderFns } from "./feedback-detail.vue?vue&type=template&id=569125aa&scoped=true&"
import script from "./feedback-detail.vue?vue&type=script&lang=js&"
export * from "./feedback-detail.vue?vue&type=script&lang=js&"
import style0 from "./feedback-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./feedback-detail.vue?vue&type=style&index=1&id=569125aa&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569125aa",
  null
  
)

export default component.exports